'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/9/16.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Encyclopedia = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Encyclopedia, _Component);

  function Encyclopedia() {
    (0, _classCallCheck3.default)(this, Encyclopedia);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Encyclopedia).call(this));

    _this.state = {
      images: [{
        img: 'http://tupian.goeasy.cn:9999/upload/201608255325632_e6c4ab97-88c5-441a-bd03-efa14dc26a81.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/upload/201608254924237_8b543ecb-893f-49eb-b0ee-63ffdc2eee65.jpg'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(Encyclopedia, [{
    key: 'render',
    value: function render() {
      var images = this.state.images;

      var carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: images });
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.IndustryHeadlinesComponent, null),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GongmeiEncyclopediaComponent, null),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return Encyclopedia;
}(_react.Component), _class.propTypes = {
  location: _react.PropTypes.object
}, _temp);
exports.default = Encyclopedia;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Encyclopedia/Encyclopedia.js
 ** module id = 1464
 ** module chunks = 0
 **/